import { render, staticRenderFns } from "./PromoExamples.vue?vue&type=template&id=84a7a162&scoped=true&"
var script = {}
import style0 from "./PromoExamples.vue?vue&type=style&index=0&id=84a7a162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a7a162",
  null
  
)

export default component.exports